import React, { Fragment, useEffect, useRef, useState } from "react";
import * as XLSX from "xlsx";
import { withRouter } from "react-router-dom";
import moment from "moment";
import DatePicker from "react-datepicker";
import { connect } from "react-redux";
import { compose } from "redux";
import { CircularProgress } from "@material-ui/core";
import { REQAnalyticPVDList, REQAnalyticPVDExcelDownload, CleanUpAnalyticPVDExcelDownload } from "./redux/actions";
import DateInput from "./DateInput";
import Pagination from "./Pagination";
import "./style.scss";

function AnalyticPVDList(props) {
    const {
        REQAnalyticPVDList,
        REQAnalyticPVDExcelDownload,
        CleanUpAnalyticPVDExcelDownload,
        REQStrAnalyticPVDList,
        AnalyticPVDList,
        AnalyticPVDExcelDownload,
        REQStrAnalyticPVDExcelDownload,
        AnalyticPVDExcelProgress,
        history
    } = props;

    // Debug: Log the full Redux state for AnalyticPVDList
    useEffect(() => {
        console.log('AnalyticPVDList (from Redux):', AnalyticPVDList);
    }, [AnalyticPVDList]);

    // State
    const [tStartD, SETxStartD] = useState(() => moment().startOf('month').toDate());
    const [tEndD, SETxEndD] = useState(() => moment().endOf('month').toDate());
    const [bAllD, SETbAllD] = useState(false);
    const [filterType, setFilterType] = useState("b2c");
    const [sortBy, setSortBy] = useState("b2c_create_date");
    const [sortOrder, setSortOrder] = useState("desc");
    const [nPageIndex, SETxPageIndex] = useState(0);
    const downloadRequested = useRef(false);
    const hasMounted = useRef(false);

    // Auto-update sort field when filter type changes
    useEffect(() => {
        if (filterType === "pvd") {
            setSortBy("pvd_regis_date");
        } else {
            setSortBy("b2c_create_date");
        }
    }, [filterType]);

    // Fetch data on mount or when search params change
    const CALLxAnalyticPVD = () => {
        if (!history.location.UISearch) {
            REQAnalyticPVDList({
                tStartD,
                tEndD,
                bAllD,
                page: nPageIndex + 1,
                per_page: 50,
                filterType
            });
        } else {
            SETxStartD(new Date(history.location.UISearch.tStartD));
            SETxEndD(new Date(history.location.UISearch.tEndD));
            SETbAllD(history.location.UISearch.bAllD);
            REQAnalyticPVDList({
                tStartD: history.location.UISearch.tStartD,
                tEndD: history.location.UISearch.tEndD,
                bAllD: history.location.UISearch.bAllD,
                page: nPageIndex + 1,
                per_page: 10,
                filterType
            });
        }
    };

    const SRCHxAnalyticAct = () => {
        SETxPageIndex(0); // Reset to first page on new search

        // Map frontend sort field to API sort field
        const sortFieldMap = {
            'b2c_create_date': 'B2C_CreateDate',
            'pvd_regis_date': 'pvd_regis_date',

            'client_email': 'Client_Email',
            'username': 'Username',
            'seq': 'Sequence'
        };

        const apiSortBy = sortFieldMap[sortBy] || 'B2C_CreateDate';

        console.log('🔍 Search initiated with params:', {
            startDate: moment(tStartD).format('YYYY-MM-DD'),
            endDate: moment(tEndD).format('YYYY-MM-DD'),
            sortBy: apiSortBy,
            sortOrder: sortOrder,
            filterType: filterType
        });

        REQAnalyticPVDList({
            tStartD,
            tEndD,
            bAllD,
            page: 1,
            per_page: 50,
            sort_by: apiSortBy,
            sort_order: sortOrder,
            filterType
        });
    };

    const SETxChangeHighlight = () => {
        REQAnalyticPVDList({
            tStartD,
            tEndD,
            bAllD: !bAllD
        });

        SETbAllD(!bAllD);
    };

    const SETxActTableClick = (ptAccStatusCodeType) => {
        localStorage.setItem('currentAnalyticPVDDetail', JSON.stringify({
            pathname: '/AnalyticPVDDetail',
            AccStatusCodeType: ptAccStatusCodeType,
            UISearch: {
                tStartD: tStartD,
                tEndD: tEndD,
                bAllD: bAllD
            }
        }))
        history.push({
            pathname: '/AnalyticPVDDetail', AccStatusCodeType: ptAccStatusCodeType,
            UISearch: {
                tStartD: tStartD,
                tEndD: tEndD,
                bAllD: bAllD
            }
        });
    };
    // Table sort helper (not used, can be removed if not needed)

    useEffect(() => {
        CALLxAnalyticPVD();
    }, []);

    // Handle sort changes - call API with new sort params
    useEffect(() => {
        // Skip on initial mount — CALLxAnalyticPVD() already handles the first fetch
        if (!hasMounted.current) {
            hasMounted.current = true;
            return;
        }
        const sortFieldMap = {
            'b2c_create_date': 'B2C_CreateDate',
            'pvd_regis_date': 'pvd_regis_date',
            'client_email': 'Client_Email',
            'username': 'Username',
            'seq': 'Sequence'
        };
        const apiSortBy = sortFieldMap[sortBy] || 'B2C_CreateDate';

        REQAnalyticPVDList({
            tStartD,
            tEndD,
            bAllD,
            page: nPageIndex + 1,
            per_page: 50,
            sort_by: apiSortBy,
            sort_order: sortOrder,
            filterType
        });
    }, [sortBy, sortOrder]);

    const handleDownloadExcel = () => {
        downloadRequested.current = true;
        // Dispatch the Excel download action with current filters
        const sortFieldMap = {
            'b2c_create_date': 'B2C_CreateDate',
            'pvd_regis_date': 'pvd_regis_date',
            'client_email': 'Client_Email',
            'username': 'Username',
            'seq': 'Sequence'
        };
        const apiSortBy = sortFieldMap[sortBy] || 'B2C_CreateDate';

        REQAnalyticPVDExcelDownload({
            tStartD,
            tEndD,
            bAllD,
            sort_by: apiSortBy,
            sort_order: sortOrder,
            filterType
        });
    };

    // Download Excel when data is ready - build worksheet in 10k-row chunks to avoid
    // allocating one massive object for large exports (100k-200k rows)
    useEffect(() => {
        if (!downloadRequested.current) return;

        // Wait until request finishes, then always clear the request flag.
        if (REQStrAnalyticPVDExcelDownload) return;

        if (AnalyticPVDExcelDownload && Array.isArray(AnalyticPVDExcelDownload) && AnalyticPVDExcelDownload.length > 0) {
            const SHEET_CHUNK = 10000;
            const ws = XLSX.utils.json_to_sheet(AnalyticPVDExcelDownload.slice(0, SHEET_CHUNK));
            for (let i = SHEET_CHUNK; i < AnalyticPVDExcelDownload.length; i += SHEET_CHUNK) {
                XLSX.utils.sheet_add_json(
                    ws,
                    AnalyticPVDExcelDownload.slice(i, i + SHEET_CHUNK),
                    { skipHeader: true, origin: -1 }
                );
            }
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'PVD Analytics');
            XLSX.writeFile(wb, `analytic_pvd_export_${moment().format('YYYYMMDD_HHmmss')}.xlsx`);
            // Free the large array from Redux state after the file is written
            CleanUpAnalyticPVDExcelDownload();
        }

        // Also reset when request completes with empty result or after failure/reset.
        downloadRequested.current = false;
    }, [AnalyticPVDExcelDownload, REQStrAnalyticPVDExcelDownload]);
    // Pagination helper
    const SETxPageGo = (pnPageAt) => {
        SETxPageIndex(pnPageAt);
        const sortFieldMap = {
            'b2c_create_date': 'B2C_CreateDate',
            'pvd_regis_date': 'pvd_regis_date',
            'client_email': 'Client_Email',
            'username': 'Username',
            'seq': 'Sequence'
        };
        const apiSortBy = sortFieldMap[sortBy] || 'B2C_CreateDate';
        REQAnalyticPVDList({
            tStartD,
            tEndD,
            bAllD,
            page: pnPageAt + 1,
            per_page: 50,
            sort_by: apiSortBy,
            sort_order: sortOrder,
            filterType
        });
    };
    const CALxPaging = () => {
        // Use API pagination info if available
        const pagination = AnalyticPVDList?.pagination;

        if (pagination) {
            // Using real API pagination
            return pagination.total_pages > 1 ? (
                <Pagination
                    nPageIndex={nPageIndex}
                    total={pagination.total_pages}
                    gotoPage={SETxPageGo}
                />
            ) : null;
        }

        return null;
    };    // Get summary data from API response
    // Robust summary mapping: fallback to 0 if keys missing
    // const summaryDataRaw = AnalyticPVDList?.summary || {};
    // const summaryData = {
    //     totalUsers: summaryDataRaw.totalUsers ?? summaryDataRaw.total_users ?? summaryDataRaw.totalCount ?? 0,
    //     mfUnitholder: summaryDataRaw.mfUnitholder ?? summaryDataRaw.mf_unitholder ?? summaryDataRaw.mfUnitholderCount ?? 0,
    //     pvdUnitholder: summaryDataRaw.pvdUnitholder ?? summaryDataRaw.pvd_unitholder ?? summaryDataRaw.pvdUnitholderCount ?? 0,
    //     noUnitholder:
    //         summaryDataRaw.noUnitholder ?? summaryDataRaw.no_unitholder ??
    //         (summaryDataRaw.totalCount !== undefined && summaryDataRaw.mfUnitholderCount !== undefined && summaryDataRaw.pvdUnitholderCount !== undefined
    //             ? summaryDataRaw.totalCount - summaryDataRaw.mfUnitholderCount - summaryDataRaw.pvdUnitholderCount
    //             : 0)
    // };
    const displayData = AnalyticPVDList?.results || [];

    // Debug: Log API response data
    // useEffect(() => {
    //     if (AnalyticPVDList) {
    //         console.log('PVD List Response:', AnalyticPVDList);
    //         console.log('Results:', AnalyticPVDList?.results);
    //         console.log('Pagination:', AnalyticPVDList?.pagination);
    //         console.log('Summary:', AnalyticPVDList?.summary);
    //     }
    // }, [AnalyticPVDList]);

    // API data is already paginated and sorted by backend
    // Map pvd_regis_date for display if present, fallback to pvd_registration_date or pvd_create_date if not
    const currentPageData = displayData.map(row => ({
        ...row,
        pvd_regis_date: row.pvd_regis_date || row.pvd_registration_date || row.pvd_create_date || '-'
    }));

    return (
        <Fragment>
            {/* Spacing for Breadcrumb */}
            <div style={{ height: "60px" }} />            {/* Main Container */}
            <div style={{
                padding: "0 70px 0 20px",
                maxWidth: "100%",
                boxSizing: "border-box",
                overflow: "hidden"
            }}>
                {/* Top Filter Section */}
                <div style={{
                    padding: "20px",
                    marginBottom: "20px",
                    borderRadius: "8px",
                    boxSizing: "border-box"
                }}>
                    {/* Filter Heading */}
                    <h3 style={{
                        margin: 0,
                        marginBottom: "20px",
                        fontWeight: "bold",
                        fontSize: "18px",
                        fontFamily: "Lato"
                    }}>

                    </h3>

                    {/* Filter Controls Row */}
                    <div style={{ display: "flex", alignItems: "center", gap: "20px", flexWrap: "wrap" }}>
                        {/* Start Date */}
                        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                            <label style={{ fontWeight: "bold", fontSize: "14px" }}>start date</label>
                            <DatePicker
                                selected={tStartD}
                                onChange={date => SETxStartD(date)}
                                dateFormat="dd/MM/yyyy"
                                customInput={<DateInput />}
                                className="date-range-input"
                            />
                        </div>

                        {/* End Date */}
                        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                            <label style={{ fontWeight: "bold", fontSize: "14px" }}>end date</label>
                            <DatePicker
                                selected={tEndD}
                                onChange={date => moment(date).isAfter(tStartD) && SETxEndD(date)}
                                dateFormat="dd/MM/yyyy"
                                customInput={<DateInput />}
                                className="date-range-input"
                            />
                        </div>

                        {/* Radio buttons */}
                        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                            <label style={{ fontWeight: "bold", fontSize: "14px" }}>filter by</label>
                            <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                                <label style={{ display: "flex", alignItems: "center", gap: "5px", cursor: "pointer" }}>
                                    <input
                                        type="radio"
                                        checked={filterType === "b2c"}
                                        onChange={() => setFilterType("b2c")}
                                    />
                                    <span style={{ fontSize: "14px" }}>by b2c create date</span>
                                </label>
                                <label style={{ display: "flex", alignItems: "center", gap: "5px", cursor: "pointer" }}>
                                    <input
                                        type="radio"
                                        checked={filterType === "pvd"}
                                        onChange={() => setFilterType("pvd")}
                                    />
                                    <span style={{ fontSize: "14px" }}>by pvd registration date</span>
                                </label>
                            </div>
                        </div>

                        {/* Sort Order Dropdown */}
                        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                            <label style={{ fontWeight: "bold", fontSize: "14px" }}>sort order</label>
                            <select
                                value={sortOrder}
                                onChange={(e) => setSortOrder(e.target.value)}
                                style={{
                                    padding: "8px 12px",
                                    fontSize: "14px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    backgroundColor: "#fff",
                                    cursor: "pointer",
                                    fontFamily: "Lato",
                                    minWidth: "150px"
                                }}
                            >
                                <option value="desc">Newest First (DESC)</option>
                                <option value="asc">Oldest First (ASC)</option>
                            </select>
                        </div>

                        {/* Download Excel Button */}
                        <button
                            style={{
                                padding: "10px 30px",
                                background: "#0072B5",
                                cursor: "pointer",
                                borderRadius: "4px",
                                marginLeft: "auto",
                                fontWeight: "bold",
                                fontSize: "14px",
                                color: "#fff",
                                border: "none"
                            }}
                            onClick={handleDownloadExcel}
                        >
                            download excel
                        </button>        </div>

                    {/* Search Button Row */}
                    <div style={{ display: "flex", justifyContent: "flex-start", marginTop: "25px" }}>
                        <button
                            style={{
                                padding: "12px 60px",
                                background: "#0072B5",
                                cursor: "pointer",
                                borderRadius: "4px",
                                fontWeight: "bold",
                                fontSize: "16px",
                                color: "#fff",
                                border: "none",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                            }}
                            onClick={SRCHxAnalyticAct}
                        >                        Search                    </button>
                    </div>
                </div>

                {/* Excel Download Loading State */}
                {REQStrAnalyticPVDExcelDownload && (
                    <div className="regisDevice-list-progress">
                        <CircularProgress />
                        <p className="regisDevice-list-progress-text">
                            {AnalyticPVDExcelProgress
                                ? `Fetching records... (page ${AnalyticPVDExcelProgress.current} of ${AnalyticPVDExcelProgress.total})`
                                : 'Preparing export...'}
                        </p>
                    </div>
                )}

                {/* Data Loading State */}
                {REQStrAnalyticPVDList ? (
                    <div className="regisDevice-list-progress">
                        <CircularProgress />
                        <p className="regisDevice-list-progress-text">
                            Retrieving Analytic PVD Conversion list...
                        </p>
                    </div>
                ) : (
                    <>
                        {/* Summary Section */}
                        {/* <div style={{
                            padding: "10px 20px",
                            background: "#0072B5",
                            borderRadius: "8px",
                            marginBottom: "20px",
                            boxSizing: "border-box"
                        }}>
                            <h3 style={{
                                margin: 0,
                                marginBottom: "10px",
                                fontWeight: "800",
                                fontSize: "18px",
                                fontFamily: "Lato",
                                textAlign: "center",
                                color: "#ffffff",
                                letterSpacing: "0.8px",
                                textTransform: "uppercase"
                            }}>
                                Summary
                            </h3>

                            <div style={{ display: "flex", gap: "0px", justifyContent: "stretch", flexWrap: "wrap" }}>                                {/* Total Users Card */}
                        {/*        <div style={{
                                    background: "#0072B5",
                                    padding: "10px 20px",
                                    flex: "1",
                                    minWidth: "150px",
                                    textAlign: "center",
                                    borderRight: "2px solid rgba(255, 255, 255, 0.3)",
                                    transition: "all 0.3s ease",
                                    cursor: "pointer"
                                }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = "translateY(-4px)";
                                        e.currentTarget.style.background = "#005a94";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "translateY(0)";
                                        e.currentTarget.style.background = "#0072B5";
                                    }}>
                                    <div style={{
                                        fontWeight: "600",
                                        marginBottom: "6px",
                                        color: "#ffffff",
                                        fontSize: "12px",
                                        lineHeight: "1.2",
                                        letterSpacing: "0.2px"
                                    }}>Total Users</div>
                                    <div style={{
                                        fontSize: "26px",
                                        fontWeight: "700",
                                        color: "#ffffff",
                                        fontFamily: "Lato"
                                    }}>{summaryData.totalUsers || 0}</div>
                                </div>                                {/* MF Unitholder Card */}
                        {/*        <div style={{
                                    background: "#0072B5",
                                    padding: "10px 20px",
                                    flex: "1",
                                    minWidth: "150px",
                                    textAlign: "center",
                                    borderRight: "2px solid rgba(255, 255, 255, 0.3)",
                                    transition: "all 0.3s ease",
                                    cursor: "pointer"
                                }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = "translateY(-4px)";
                                        e.currentTarget.style.background = "#005a94";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "translateY(0)";
                                        e.currentTarget.style.background = "#0072B5";
                                    }}>
                                    <div style={{
                                        fontWeight: "600",
                                        marginBottom: "6px",
                                        color: "#ffffff",
                                        fontSize: "12px",
                                        lineHeight: "1.2",
                                        letterSpacing: "0.2px"
                                    }}>MF Unitholders</div>
                                    <div style={{
                                        fontSize: "26px",
                                        fontWeight: "700",
                                        color: "#ffffff",
                                        fontFamily: "Lato"
                                    }}>{summaryData.mfUnitholder || 0}</div>
                                </div>                                {/* PVD Unitholder Card */}
                        {/*        <div style={{
                                    background: "#0072B5",
                                    padding: "10px 20px",
                                    flex: "1",
                                    minWidth: "150px",
                                    textAlign: "center",
                                    borderRight: "2px solid rgba(255, 255, 255, 0.3)",
                                    transition: "all 0.3s ease",
                                    cursor: "pointer"
                                }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = "translateY(-4px)";
                                        e.currentTarget.style.background = "#005a94";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "translateY(0)";
                                        e.currentTarget.style.background = "#0072B5";
                                    }}>
                                    <div style={{
                                        fontWeight: "600",
                                        marginBottom: "6px",
                                        color: "#ffffff",
                                        fontSize: "12px",
                                        lineHeight: "1.2",
                                        letterSpacing: "0.2px"
                                    }}>PVD Unitholders</div>
                                    <div style={{
                                        fontSize: "26px",
                                        fontWeight: "700",
                                        color: "#ffffff",
                                        fontFamily: "Lato"
                                    }}>{summaryData.pvdUnitholder || 0}</div>
                                </div>                                {/* No Unitholder Card */}
                        {/*        <div style={{
                                    background: "#0072B5",
                                    padding: "10px 20px",
                                    flex: "1",
                                    minWidth: "150px",
                                    textAlign: "center",
                                    transition: "all 0.3s ease",
                                    cursor: "pointer"
                                }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = "translateY(-4px)";
                                        e.currentTarget.style.background = "#005a94";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "translateY(0)";
                                        e.currentTarget.style.background = "#0072B5";
                                    }}>
                                    <div style={{
                                        fontWeight: "600",
                                        marginBottom: "6px",
                                        color: "#ffffff",
                                        fontSize: "12px",
                                        lineHeight: "1.2",
                                        letterSpacing: "0.2px"
                                    }}>No Unitholders</div>
                                    <div style={{
                                        fontSize: "26px",
                                        fontWeight: "700",
                                        color: "#ffffff",
                                        fontFamily: "Lato"
                                    }}>{summaryData.noUnitholder || 0}</div>                                </div>                            </div>
                        </div> */}

                        {/* Table Section Wrapper */}
                        <div style={{
                            marginBottom: "20px",
                            padding: "20px",
                            background: "#ffffff",
                            borderRadius: "8px",
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
                            boxSizing: "border-box"
                        }}>
                            {/* Pagination Info */}
                            {AnalyticPVDList?.pagination && (
                                <div style={{
                                    marginBottom: "15px",
                                    fontSize: "14px",
                                    color: "#555",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}>
                                    <div>
                                        Showing <strong>{((AnalyticPVDList.pagination.current_page - 1) * AnalyticPVDList.pagination.per_page) + 1}</strong> to{" "}
                                        <strong>
                                            {Math.min(
                                                AnalyticPVDList.pagination.current_page * AnalyticPVDList.pagination.per_page,
                                                AnalyticPVDList.pagination.total_count
                                            )}
                                        </strong>{" "}
                                        of <strong>{AnalyticPVDList.pagination.total_count}</strong> results
                                    </div>
                                    <div>
                                        Page <strong>{AnalyticPVDList.pagination.current_page}</strong> of{" "}
                                        <strong>{AnalyticPVDList.pagination.total_pages}</strong>
                                    </div>
                                </div>
                            )}                            {/* Table Container */}
                            <div style={{
                                //border: "solid 1px rgba(0, 0, 0, 0.1)",
                                borderRadius: "4px",
                                overflow: "hidden",
                                overflowX: "auto"
                            }}>
                                {/* Table Wrapper - Fixed minimum width */}
                                <div style={{ minWidth: "1400px" }}>
                                    {/* Table Header */}
                                    <div style={{
                                        display: "grid",
                                        gridTemplateColumns: "60px 200px 200px 150px 100px 150px 120px 120px 180px 120px",
                                        background: "#ffffff",
                                        borderBottom: "solid 1px rgba(0, 0, 0, 0.1)",
                                        height: "62px"
                                    }}>
                                        <div style={{
                                            padding: "0 10px",
                                            fontFamily: "Lato",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            color: "#000000",
                                            letterSpacing: "0.2px",
                                            // // borderRight: "1px solid rgba(0, 0, 0, 0.05)",
                                            textAlign: "center",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center"
                                        }}>Seq</div>
                                        <div style={{
                                            padding: "0 20px",
                                            fontFamily: "Lato",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            color: "#000000",
                                            letterSpacing: "0.2px",
                                            // // borderRight: "1px solid rgba(0, 0, 0, 0.05)",
                                            display: "flex",
                                            alignItems: "center"
                                        }}>Client Email</div>
                                        <div style={{
                                            padding: "0 20px",
                                            fontFamily: "Lato",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            color: "#000000",
                                            letterSpacing: "0.2px",
                                            // borderRight: "1px solid rgba(0, 0, 0, 0.05)",
                                            display: "flex",
                                            alignItems: "center"
                                        }}>Username</div>
                                        <div style={{
                                            padding: "0 20px",
                                            fontFamily: "Lato",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            color: "#000000",
                                            letterSpacing: "0.2px",
                                            // borderRight: "1px solid rgba(0, 0, 0, 0.05)",
                                            display: "flex",
                                            alignItems: "center"
                                        }}>B2C Create Date</div>
                                        <div style={{
                                            padding: "0 10px",
                                            fontFamily: "Lato",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            color: "#000000",
                                            letterSpacing: "0.2px",
                                            // borderRight: "1px solid rgba(0, 0, 0, 0.05)",
                                            textAlign: "center",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center"
                                        }}>MF Unitholder</div>
                                        <div style={{
                                            padding: "0 20px",
                                            fontFamily: "Lato",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            color: "#000000",
                                            letterSpacing: "0.2px",
                                            // borderRight: "1px solid rgba(0, 0, 0, 0.05)",
                                            display: "flex",
                                            alignItems: "center"
                                        }}>PVD Regis Date</div>
                                        <div style={{
                                            padding: "0 20px",
                                            fontFamily: "Lato",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            color: "#000000",
                                            letterSpacing: "0.2px",
                                            // borderRight: "1px solid rgba(0, 0, 0, 0.05)",
                                            display: "flex",
                                            alignItems: "center"
                                        }}>PVD Mem ID</div>
                                        <div style={{
                                            padding: "0 20px",
                                            fontFamily: "Lato",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            color: "#000000",
                                            letterSpacing: "0.2px",
                                            // borderRight: "1px solid rgba(0, 0, 0, 0.05)",
                                            display: "flex",
                                            alignItems: "center"
                                        }}>PVD Mem Code</div>
                                        <div style={{
                                            padding: "0 20px",
                                            fontFamily: "Lato",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            color: "#000000",
                                            letterSpacing: "0.2px",
                                            // borderRight: "1px solid rgba(0, 0, 0, 0.05)",
                                            display: "flex",
                                            alignItems: "center"
                                        }}>PVD Name</div>
                                        <div style={{
                                            padding: "0 20px",
                                            fontFamily: "Lato",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            color: "#000000",
                                            letterSpacing: "0.2px",
                                            display: "flex",
                                            alignItems: "center"
                                        }}>Investor Code</div>
                                    </div>

                                    {/* Table Body */}
                                    <div>
                                        {currentPageData.map((row, index) => (
                                            <div
                                                key={row.id}
                                                style={{
                                                    display: "grid",
                                                    gridTemplateColumns: "60px 200px 200px 150px 100px 150px 120px 120px 180px 120px",
                                                    borderBottom: index === currentPageData.length - 1 ? "none" : "solid 1px rgba(0, 0, 0, 0.1)",
                                                    background: index % 2 === 0 ? "#ededed" : "#ffffff",
                                                    height: "66px"
                                                }}
                                            >
                                                <div style={{
                                                    padding: "0 10px",
                                                    fontFamily: "Lato",
                                                    fontSize: "14px",
                                                    fontWeight: "normal",
                                                    lineHeight: "1.29",
                                                    letterSpacing: "0.2px",
                                                    color: "#000000",
                                                    textAlign: "center",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    textOverflow: "ellipsis",
                                                    overflow: "hidden"
                                                }}>{row.seq}</div>
                                                <div style={{
                                                    padding: "0 20px",
                                                    fontFamily: "Lato",
                                                    fontSize: "14px",
                                                    fontWeight: "normal",
                                                    lineHeight: "1.29",
                                                    letterSpacing: "0.2px",
                                                    color: "#000000",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    overflow: "break-word",
                                                    wordBreak: "break-all",
                                                    whiteSpace: "pre-line"
                                                }} title={row.client_email}>{row.client_email}</div>
                                                <div style={{
                                                    padding: "0 20px",
                                                    fontFamily: "Lato",
                                                    fontSize: "14px",
                                                    fontWeight: "normal",
                                                    lineHeight: "1.29",
                                                    letterSpacing: "0.2px",
                                                    color: "#000000",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    overflow: "break-word",
                                                    wordBreak: "break-all",
                                                    whiteSpace: "pre-line"
                                                }} title={row.username}>{row.username}</div>
                                                <div style={{
                                                    padding: "0 20px",
                                                    fontFamily: "Lato",
                                                    fontSize: "14px",
                                                    fontWeight: "normal",
                                                    lineHeight: "1.29",
                                                    letterSpacing: "0.2px",
                                                    color: "#000000",
                                                    display: "flex",
                                                    alignItems: "center"
                                                }}>{row.b2c_create_date && row.b2c_create_date !== '-' ? moment.utc(row.b2c_create_date).add(7, 'hours').format('DD/MM/YYYY HH:mm') : '-'}</div>
                                                <div style={{
                                                    padding: "0 10px",
                                                    fontFamily: "Lato",
                                                    fontSize: "14px",
                                                    fontWeight: "normal",
                                                    lineHeight: "1.29",
                                                    letterSpacing: "0.2px",
                                                    color: "#000000",
                                                    textAlign: "center",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center"
                                                }}>
                                                    {row.mf_unitholder ? (
                                                        <span style={{
                                                            padding: "4px 8px",
                                                            borderRadius: "12px",
                                                            fontSize: "11px",
                                                            fontWeight: "500",
                                                            background: "#e3f2fd",
                                                            color: "#1976d2"
                                                        }}>{row.mf_unitholder}</span>
                                                    ) : (
                                                        <span style={{ color: "#999" }}>-</span>
                                                    )}
                                                </div>
                                                <div style={{
                                                    padding: "0 20px",
                                                    fontFamily: "Lato",
                                                    fontSize: "14px",
                                                    fontWeight: "normal",
                                                    lineHeight: "1.29",
                                                    letterSpacing: "0.2px",
                                                    color: "#000000",
                                                    display: "flex",
                                                    alignItems: "center"
                                                }}>{row.pvd_regis_date && row.pvd_regis_date !== '-' ? moment.utc(row.pvd_regis_date).add(7, 'hours').format('DD/MM/YYYY HH:mm') : '-'}</div>
                                                <div style={{
                                                    padding: "0 20px",
                                                    fontFamily: "Lato",
                                                    fontSize: "14px",
                                                    fontWeight: "normal",
                                                    lineHeight: "1.29",
                                                    letterSpacing: "0.2px",
                                                    color: "#000000",
                                                    display: "flex",
                                                    alignItems: "center"
                                                }}>{row.pvd_mem_id || '-'}</div>
                                                <div style={{
                                                    padding: "0 20px",
                                                    fontFamily: "Lato",
                                                    fontSize: "14px",
                                                    fontWeight: "normal",
                                                    lineHeight: "1.29",
                                                    letterSpacing: "0.2px",
                                                    color: "#000000",
                                                    display: "flex",
                                                    alignItems: "center"
                                                }}>{row.pvd_mem_code || '-'}</div>
                                                <div style={{
                                                    padding: "0 20px",
                                                    fontFamily: "Lato",
                                                    fontSize: "14px",
                                                    fontWeight: "normal",
                                                    lineHeight: "1.29",
                                                    letterSpacing: "0.2px",
                                                    color: "#000000",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap"
                                                }} title={row.pvd_name}>{row.pvd_name || '-'}</div>
                                                <div style={{
                                                    padding: "0 20px",
                                                    fontFamily: "Lato",
                                                    fontSize: "14px",
                                                    fontWeight: "normal",
                                                    lineHeight: "1.29",
                                                    letterSpacing: "0.2px",
                                                    color: "#000000", display: "flex",
                                                    alignItems: "center"
                                                }}>{row.investor_code || '-'}</div>
                                            </div>
                                        ))}
                                    </div>                                </div>
                            </div>
                        </div>

                        {/* Pagination - Outside Table Section */}
                        <div style={{
                            marginBottom: "20px",
                            boxSizing: "border-box"
                        }}>
                            <CALxPaging />
                        </div>
                    </>
                )}
            </div> {/* End Main Container */}
        </Fragment>
    );
}



const withConnect = connect(
    state => ({
        ...state.analyticListReducer,
        AnalyticPVDExcelDownload: state.analyticListReducer.AnalyticPVDExcelDownload,
        REQStrAnalyticPVDExcelDownload: state.analyticListReducer.REQStrAnalyticPVDExcelDownload,
        AnalyticPVDExcelProgress: state.analyticListReducer.AnalyticPVDExcelProgress
    }),
    {
        REQAnalyticPVDList,
        REQAnalyticPVDExcelDownload,
        CleanUpAnalyticPVDExcelDownload
    }
);

export default compose(
    withConnect,
    withRouter
)(AnalyticPVDList);